import type { ReactNode } from 'react';
import { useId } from 'react';

type Props = {
  rotulo: string;
  children: (id: string) => ReactNode;
  dica?: string;
  /** Marca o campo com * vermelho — sinal visual de preenchimento obrigatório. */
  obrigatorio?: boolean;
  /** Classe extra no `<label>` — posição do campo num grid, por exemplo. */
  className?: string;
};

/** Asterisco de campo obrigatório, para rótulos montados fora do `Field`. */
export function MarcaObrigatorio() {
  return (
    <span className="field__obrigatorio" aria-hidden="true">
      *
    </span>
  );
}

export function Field({ rotulo, children, dica, obrigatorio, className }: Props) {
  const id = useId();
  return (
    <label className={className ? `field ${className}` : 'field'} htmlFor={id}>
      <span className="field__label">
        {rotulo}
        {obrigatorio && <MarcaObrigatorio />}
        {obrigatorio && <span className="sr-only"> (obrigatório)</span>}
      </span>
      {children(id)}
      {dica && <span className="field__hint">{dica}</span>}
    </label>
  );
}
